import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export const getShipmentFieldsVisibilityAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentFieldsVisiblity`,
  });
};

export type ShipmentFieldsVisibilityResponse = {
  customerKey: number;
  columnName: string;
  moduleName: string; // 'Shipment'
  isVisible: 0 | 1;
}[];

export const fetchShipmentFieldsVisibility = async (): Promise<ShipmentFieldsVisibilityResponse> => {
  const response: AxiosResponse<ShipmentFieldsVisibilityResponse> = await getShipmentFieldsVisibilityAPI();
  return response.data;
};
